import React from 'react';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import { transformTendenciaData, formatAbreviado } from './dataTransforms';
import { CHART_COLORS } from './chartColors';

function CustomTooltip({ active, payload }) {
  if (!active || !payload || !payload.length) return null;
  const { fecha, monto } = payload[0].payload;
  return (
    <div
      style={{
        background: '#fff',
        border: '1px solid #ccc',
        borderRadius: 4,
        padding: '8px 12px',
      }}
    >
      <p style={{ margin: 0, fontWeight: 'bold' }}>{fecha}</p>
      <p style={{ margin: 0 }}>${monto.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
    </div>
  );
}

export default function AreaLineChart({ data }) {
  const chartData = transformTendenciaData(data);

  if (!chartData || chartData.length === 0) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: 300,
          color: '#999',
        }}
      >
        Sin datos de tendencia disponibles
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <AreaChart data={chartData}>
        <defs>
          <linearGradient id="colorTendencia" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor={CHART_COLORS.TENDENCIA} stopOpacity={0.8} />
            <stop offset="95%" stopColor={CHART_COLORS.TENDENCIA} stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="fecha" />
        <YAxis tickFormatter={(value) => formatAbreviado(value)} />
        <Tooltip content={<CustomTooltip />} />
        <Area
          type="monotone"
          dataKey="monto"
          stroke={CHART_COLORS.TENDENCIA}
          fill="url(#colorTendencia)"
        />
      </AreaChart>
    </ResponsiveContainer>
  );
}
